import './DashboardEditor.scss';

import React from 'react';
import IconButton from '@mui/material/IconButton';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

interface DashboardEditorRowProps {
  row: any;
  index: number;
  onRemove: (index: number) => void;
  onDragStart: (index: number, e: React.PointerEvent) => void;
  md?: number;
  children: React.ReactNode;
}

export default function DashboardEditorRow ({ row, index, onRemove, onDragStart, md, children }: DashboardEditorRowProps) {
  return (
    <div
      className='editor-row'
      style={{ gridColumn: `span ${md || 12}` }}
      data-editor-id={row._editorId}
      data-drop-target
    >
      <div className='editor-row-controls'>
        <div
          className='editor-row-drag-handle'
          onPointerDown={(e) => {
            e.preventDefault();
            onDragStart(index, e);
          }}
        >
          <DragIndicatorIcon />
        </div>
        <IconButton
          className='editor-row-remove-btn'
          size='small'
          onClick={() => onRemove(index)}
        >
          <DeleteOutlineIcon />
        </IconButton>
      </div>
      <div className='editor-row-content'>
        {children}
      </div>
    </div>
  );
}
